import cn from 'classnames'

import c from './assets/sass/robot.module.scss'

export const Robot = ({ state }) => {
    const handleClick = () => {
        if (window.energyTap && state === 2) {
            window.energyTap()
            // Эффект монетки: нужно отрисовать анимацию
            try {
                window.dispatchEvent(
                    new CustomEvent('gg:coin-pop', {
                        detail: { ts: Date.now() },
                    })
                )
            } catch {}
        }
    }

    return (
        <div
            className={cn(c.component, {
                [c.loader]: state === 0,
                [c.login]: state === 1,
            })}
        >
            <div className={c.row}>
                <div
                    className={c.robot}
                    onClick={handleClick}
                    style={{ cursor: state === 2 ? 'pointer' : 'default' }}
                />
            </div>
        </div>
    )
}
